function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $controller, $helpers, Array, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['search-match-parts'] = function(matches) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (matches);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'match-part': true
                  },
                }, [__vjadeSafeCode(part)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var $index = $$objKey;
                if ($$obj.hasOwnProperty($index)) {
                  $$iterated = true;
                  var part = $$obj[$index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'match-part': true
                      },
                    }, [__vjadeSafeCode(part)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['list-option-label'] = function(item) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'option-label-section': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": {
              title: item.label
            },
            "class": Object.assign({}, {
              [`theme-${item.labelTheme}`]: item.labelTheme,
              'truncate': !item.wrapLabel,
            }, {
              'option-label': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((item.labelMatch) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['search-match-parts'].call(this, item.labelMatch.matchParts));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'label': true
                },
              }, [__vjadeSafeCode(item.label)]));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((item.subLabel) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": {
                title: item.subLabel
              },
              "class": Object.assign({}, {
                [`theme-${item.subLabelTheme}`]: Boolean(item.subLabelTheme),
                'truncate': !item.wrapSubLabel,
              }, {
                'option-sub-label': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((item.subLabelMatch) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['search-match-parts'].call(this, item.subLabelMatch.matchParts));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'sub-label': true
                  },
                }, [__vjadeSafeCode(item.subLabel)]));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['list-option-icon'] = function(item) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((item.icon) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": {
              icon: item.icon
            },
            "class": Object.assign({}, {
              [`align-${item.iconSide || 'left'}`]: true
            }, {
              'option-icon': true,
              'item-icon': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: item.icon,
                empty: !item.icon
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['list-option-item'] = function(item, isMultiple, isFocused, isPillFocused) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((isMultiple && !item.isExpander && !item.isControlItem) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
            "attrs": $helpers.filterAttributes({
              checked: item.isSelected,
              /** if color is not provided, will be standard $blue1 */
              'checked-color': item.isSelectAll ? `none` : (item.color || null),
              disabled: item.isDisabled,
              'unchecked-icon': item.isSelectAll ? 'dash' : '',
              focused: isFocused,
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-content'].call(this, item, isFocused, isPillFocused));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-content'].call(this, item, isFocused, isPillFocused));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['list-option-action'] = function(item, isFocused, isPillFocused) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((item.hasPill) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: !item.isPillDisabled ? (ev) => $helpers.handleClickPill(item, ev) : null,
              mouseenter: () => $controller.handleMouseenterPill(item),
              mouseleave: () => $controller.handleMouseleavePill(item),
            },
            "class": Object.assign({}, {
              focused: isFocused && isPillFocused,
              disabled: item.isPillDisabled,
            }, {
              'secondary-action': true,
              'pill': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(item.pillLabel)]));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'pill-caret': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `caret-right`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : (item.hasCaret) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'secondary-action': true,
              'caret': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: `caret-right`
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['list-option-content'] = function(item, isFocused, isPillFocused) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-icon'].call(this, item));
        __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-label'].call(this, item));
        __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-action'].call(this, item, isFocused, isPillFocused));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "hook": {
          postpatch: () => $controller.handlePostPatch()
        },
        "class": {
          'screen-list-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const {
          emptyMessage,
          focusedItemIndex,
          isPillFocused,
          searchFilter,
          sections,
          sectionsHint,
        } = $controller.getDisplayState();
        __jade_nodes = __jade_nodes.concat((!sections.length) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((searchFilter) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("li", {
              "class": {
                'list-option': true,
                'list-empty': true
              },
            }, [__vjadeSafeCode($attr(`empty-search-results-message`))]));;
            return __jade_nodes
          }).call(this)) : (emptyMessage) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("li", {
              "class": {
                'list-option': true,
                'list-empty': true
              },
            }, [__vjadeSafeCode(emptyMessage)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((sectionsHint) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sections-hint': true
              },
            }, [__vjadeSafeCode(sectionsHint)]));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (sections);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, section, idx) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((idx > 0) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'section-divider': true
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat((section.label) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'section-header': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'section-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'label': true
                          },
                        }, [__vjadeSafeCode(section.label)]));
                        __jade_nodes = __jade_nodes.concat((section.icon) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "attrs": {
                              icon: section.icon
                            },
                            "class": {
                              'section-icon': true,
                              'item-icon': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: section.icon,
                                empty: !section.icon
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((section.datasetDisplayName) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'dataset-name': true
                          },
                        }, [__vjadeSafeCode(section.datasetDisplayName)]));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat((section.isLoading) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'loading-items': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("ul", {
                      "class": {
                        'screen-options-list': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = (section.items);
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              const isFocused = focusedItemIndex === item.index;
                              const optionType = $attr(`multiple`) ? `multiple` : `select`;;
                              __jade_nodes = __jade_nodes.concat(h("li", {
                                "on": {
                                  click: !item.isDisabled ? ev => $helpers.handleClickItem(item, ev) : null,
                                  mouseenter: () => $controller.handleMouseenterItem(item),
                                },
                                "class": Object.assign({}, {
                                  [`for-${optionType}-type`]: true,
                                  disabled: item.isDisabled,
                                  expander: item.isExpander,
                                  focused: isFocused,
                                  selectable: !item.isDisabled,
                                  selected: item.isSelected,
                                  'has-tooltip': item.tooltip && item.tooltip.text,
                                }, {
                                  'list-option': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((item.tooltip && item.tooltip.text) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                    "attrs": {
                                      placement: item.tooltip.placement || `right`,
                                      'always-show': item.tooltip['always-show'] || false,
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(item.tooltip.text);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat(h("section", {
                                    "class": {
                                      'list-option-wrapper': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                  return __jade_nodes
                                }).call(this)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var item = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  const isFocused = focusedItemIndex === item.index;
                                  const optionType = $attr(`multiple`) ? `multiple` : `select`;;
                                  __jade_nodes = __jade_nodes.concat(h("li", {
                                    "on": {
                                      click: !item.isDisabled ? ev => $helpers.handleClickItem(item, ev) : null,
                                      mouseenter: () => $controller.handleMouseenterItem(item),
                                    },
                                    "class": Object.assign({}, {
                                      [`for-${optionType}-type`]: true,
                                      disabled: item.isDisabled,
                                      expander: item.isExpander,
                                      focused: isFocused,
                                      selectable: !item.isDisabled,
                                      selected: item.isSelected,
                                      'has-tooltip': item.tooltip && item.tooltip.text,
                                    }, {
                                      'list-option': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((item.tooltip && item.tooltip.text) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                        "attrs": {
                                          placement: item.tooltip.placement || `right`,
                                          'always-show': item.tooltip['always-show'] || false,
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(item.tooltip.text);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));
                                      __jade_nodes = __jade_nodes.concat(h("section", {
                                        "class": {
                                          'list-option-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                      return __jade_nodes
                                    }).call(this)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var idx = $$objKey;
                  if ($$obj.hasOwnProperty(idx)) {
                    $$iterated = true;
                    var section = $$obj[idx];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((idx > 0) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'section-divider': true
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat((section.label) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'section-header': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'section-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "class": {
                                'label': true
                              },
                            }, [__vjadeSafeCode(section.label)]));
                            __jade_nodes = __jade_nodes.concat((section.icon) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "attrs": {
                                  icon: section.icon
                                },
                                "class": {
                                  'section-icon': true,
                                  'item-icon': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": {
                                    icon: section.icon,
                                    empty: !section.icon
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((section.datasetDisplayName) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("span", {
                              "class": {
                                'dataset-name': true
                              },
                            }, [__vjadeSafeCode(section.datasetDisplayName)]));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat((section.isLoading) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'loading-items': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("ul", {
                          "class": {
                            'screen-options-list': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((function() {
                            var $$obj = (section.items);
                            var $$eachNodes;
                            var $$iterated = false;
                            if (Array.isArray($$obj)) {
                              $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                                $$iterated = true;
                                return $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  const isFocused = focusedItemIndex === item.index;
                                  const optionType = $attr(`multiple`) ? `multiple` : `select`;;
                                  __jade_nodes = __jade_nodes.concat(h("li", {
                                    "on": {
                                      click: !item.isDisabled ? ev => $helpers.handleClickItem(item, ev) : null,
                                      mouseenter: () => $controller.handleMouseenterItem(item),
                                    },
                                    "class": Object.assign({}, {
                                      [`for-${optionType}-type`]: true,
                                      disabled: item.isDisabled,
                                      expander: item.isExpander,
                                      focused: isFocused,
                                      selectable: !item.isDisabled,
                                      selected: item.isSelected,
                                      'has-tooltip': item.tooltip && item.tooltip.text,
                                    }, {
                                      'list-option': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((item.tooltip && item.tooltip.text) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                        "attrs": {
                                          placement: item.tooltip.placement || `right`,
                                          'always-show': item.tooltip['always-show'] || false,
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(item.tooltip.text);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));
                                      __jade_nodes = __jade_nodes.concat(h("section", {
                                        "class": {
                                          'list-option-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                      return __jade_nodes
                                    }).call(this)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }, []);
                            } else {
                              $$eachNodes = [];
                              for (var $$objKey in $$obj) {
                                (function() {
                                  var $index = $$objKey;
                                  if ($$obj.hasOwnProperty($index)) {
                                    $$iterated = true;
                                    var item = $$obj[$index];
                                    $$eachNodes = $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      const isFocused = focusedItemIndex === item.index;
                                      const optionType = $attr(`multiple`) ? `multiple` : `select`;;
                                      __jade_nodes = __jade_nodes.concat(h("li", {
                                        "on": {
                                          click: !item.isDisabled ? ev => $helpers.handleClickItem(item, ev) : null,
                                          mouseenter: () => $controller.handleMouseenterItem(item),
                                        },
                                        "class": Object.assign({}, {
                                          [`for-${optionType}-type`]: true,
                                          disabled: item.isDisabled,
                                          expander: item.isExpander,
                                          focused: isFocused,
                                          selectable: !item.isDisabled,
                                          selected: item.isSelected,
                                          'has-tooltip': item.tooltip && item.tooltip.text,
                                        }, {
                                          'list-option': true
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat((item.tooltip && item.tooltip.text) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                            "attrs": {
                                              placement: item.tooltip.placement || `right`,
                                              'always-show': item.tooltip['always-show'] || false,
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(item.tooltip.text);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));
                                          __jade_nodes = __jade_nodes.concat(h("section", {
                                            "class": {
                                              'list-option-wrapper': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['list-option-item'].call(this, item, $attr(`multiple`), isFocused, isPillFocused));;
                                          return __jade_nodes
                                        }).call(this)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }
                                })();
                              }
                            }

                            return $$eachNodes;
                          })());;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$controller" in locals ? locals.$controller : typeof $controller !== "undefined" ? $controller : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;